import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addPackagesButtonLabel: {
    description: 'Add package button label',
    defaultMessage: 'Add Package',
    id: 'nQERjm',
  },
  addPackageTooltip: {
    description: 'Add package tooltip',
    defaultMessage: 'Add Package',
    id: 'VewU3p',
  },
});
